const queryParser = (string, key) => {
  const array = string.replace('?', '').split('&')
  const query = {}

  array.forEach(i => {
    const [key, value] = i.split('=')
    query[key] = value
  })

  if (key) {
    return query[key]
  }
  return query
}

export default queryParser
